import React from 'react'
import { ChartContainer } from './styles'
import { Bar } from 'react-chartjs-2'

function AvgKarmaChart({xData, customer, group}) {

    const data = {
      labels: xData,
      datasets: [
        {
          label: 'Karma Points',
          data: customer,
          backgroundColor: 'rgb(255, 99, 132)',
        },
        {
          label: 'Group Avg',
          data: group,
          backgroundColor: 'rgb(255, 144, 99)',
        }
      ],
    }
    
    const options = {
      maintainAspectRatio: false,
      scales: {
        xAxes: [ {
          scaleLabel: {
            display: true,
            labelString: 'Week'
          } 
        } ],
      }
    }

    return(
          <ChartContainer className="chart-container">
              <Bar data={data} options={options}/>
          </ChartContainer>
    )
}

export default AvgKarmaChart